module.exports = __webpack_public_path__ + "static/media/cat1.4efe956d.gif";